<div [ngStyle]="{ maxWidth: config.maxWidth, width: config.width }">
  <h5 mat-dialog-title class="mat-subtitle-1">{{ config.title | translate }}</h5>
  <div mat-dialog-content class="lh-16">
    {{ config.content | translate }}
  </div>
</div>
<div mat-dialog-actions class="p-24 p-t-0 row">
  <div class="col-6"></div>
  <div class="col-3 p-l-0 p-r-8">
    <button [hidden]="config.hiddenCancel" 
            mat-flat-button mat-dialog-close 
            (click)="onCancel()" class="w-100 b-1" 
            [ngStyle]="{ backgroundColor: config.cancelColor }">
      {{ "cancel" | translate }}
    </button>
  </div>
  <div class="col-3 p-r-0 p-l-8">
    <button [hidden]="config.hiddenConfirm"
            mat-flat-button
            mat-dialog-close
            cdkFocusInitial
            (click)="onConfirm()"
            color="primary"
            class="w-100"
            [ngStyle]="{ backgroundColor: config.confirmColor }">
      {{ "Ok" | translate }}
    </button>
  </div>
</div>
